module.exports = __webpack_public_path__ + "img/kx5600-char-2.29189a1b.png";